import * as React from 'react';
import moment from 'moment-timezone';
import { useLocation } from 'react-router-dom';
import { Arbeitszeituebersicht } from './Arbeitszeituebersicht';

export const ArbeitszeituebersichtPrint: React.FC = () => {
    const location = useLocation();
    const urlSearchParams = new URLSearchParams(location.search);

    const workYearS = urlSearchParams.get('workYear');
    const workYear = workYearS ? parseInt(workYearS, 10) : moment().year();

    const workMonthS = urlSearchParams.get('workMonth');
    const workMonth = workMonthS ? parseInt(workMonthS, 10) : moment().year();

    return <Arbeitszeituebersicht workYear={workYear} workMonth={workMonth} printView />;
};
